export const FIGHT_ERROR_MESSAGES = {
  NOT_FOUND: 'Fight not found',
  SERVER_ERROR: 'Server error occurred',
};
